<template>
  <section data-aos="fade-right" data-aos-offset="200">
    <div v-bind:class="{ geometry: geometry }"/>
    <div class="section-header">
      <div class="grid-container de-skew">
        <h2 v-text="title"></h2>
        <p v-if="subtext" v-text="subtext"></p>
      </div>
      <div class="section-header-subcolor"></div>
    </div>
    <div class="section-content" data-aos="fade-left" data-aos-offset="200">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VisualDataSection',
  props: {
    title: String,
    subtext: String,
    geometry: Boolean
  }
};
</script>
